import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography, Container, Paper, Alert } from '@mui/material';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PaymentResult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Verificando tu pago...');

  useEffect(() => {
    const processPayment = async () => {
      const params = new URLSearchParams(location.search);
      const token_ws = params.get('token_ws');

      if (!token_ws) {
        setStatus('error');
        setMessage('No se encontró el token de la transacción. El pago no pudo ser verificado.');
        setTimeout(() => navigate('/booking/payment-error?reason=no_token'), 3000);
        return;
      }

      try {
        const confirmWebpay = httpsCallable(functions, 'confirmWebpayTransaction');
        const response = await confirmWebpay({ token_ws });
        const result = response.data;

        if (result.status === 'success') {
          setStatus('success');
          setMessage('¡Pago confirmado! Redirigiendo...');
          const pendingBooking = JSON.parse(localStorage.getItem('pendingBooking') || '{}');
          navigate('/booking/success', {
            state: {
              bookingCode: result.bookingCode,
              amount: result.amount,
              authorizationCode: result.authorizationCode,
              bookingDetails: pendingBooking,
            },
            replace: true,
          });
        } else {
          setStatus('error');
          setMessage(result.message || 'El pago no pudo ser completado.');
          setTimeout(() => {
            navigate(`/booking/payment-error?reason=rejected&code=${result.bookingCode || ''}`, { replace: true });
          }, 2500);
        }
      } catch (err) {
        console.error('Error confirmando pago:', err);
        setStatus('error');
        setMessage('Error al verificar el pago. Si el cargo fue realizado, contacta a soporte.');
        setTimeout(() => navigate('/booking/payment-error?reason=error', { replace: true }), 3000);
      }
    };

    processPayment();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f7fa', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 5, borderRadius: 4, textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <CircularProgress size={64} sx={{ mb: 3 }} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Verificando tu pago
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Por favor espera, no cierres ni recargues esta página...
              </Typography>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>{message}</Typography>
            </>
          )}
          {status === 'error' && (
            <>
              <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
              <Alert severity="error" sx={{ textAlign: 'left' }}>{message}</Alert>
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentResult;
